"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const intl_1 = require("@kyruus/intl");
const ArrowLeft_1 = __importDefault(require("@kyruus/react-ikons/ArrowLeft"));
const styles_1 = require("./styles");
const DesktopHeader = (0, react_1.forwardRef)((props, ref) => {
    const { goBack, headerMessage } = props;
    return (react_1.default.createElement(styles_1.StyledDesktopHeaderContainer, { ref: ref },
        react_1.default.createElement(styles_1.StyledButtonWithIcon, { onClick: goBack, icon: react_1.default.createElement(ArrowLeft_1.default, { "aria-hidden": "true" }), active: true, iconAlign: 'left', mode: "flat", "data-testid": "desktop-header" },
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, headerMessage)))));
});
DesktopHeader.displayName = 'DesktopHeader';
exports.default = DesktopHeader;
//# sourceMappingURL=DesktopHeader.js.map